
export default function About() {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-4xl font-bold text-gray-900 mb-6">
              About <span className="text-blue-600">Suncore International</span>
            </h3>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              With over <strong>20 years of experience</strong> in the industrial components industry, Suncore International FZE has established itself as a trusted partner for businesses across <strong>40+ countries</strong> worldwide.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Based in the strategic location of <strong>Jebel Ali Free Zone, Dubai</strong>, we leverage our position as a global trading hub to deliver exceptional service and quality products to our international clientele.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Our commitment to excellence is reflected in our <strong>ISO certification</strong> and our dedication to providing comprehensive industrial solutions that keep your operations running smoothly.
            </p>
            
            <div className="grid grid-cols-2 gap-6">
              <div className="text-center p-6 bg-white rounded-lg shadow-md">
                <div className="text-3xl font-bold text-blue-600 mb-2">20+</div>
                <div className="text-gray-700 font-medium">Years Experience</div>
              </div>
              <div className="text-center p-6 bg-white rounded-lg shadow-md">
                <div className="text-3xl font-bold text-blue-600 mb-2">40+</div>
                <div className="text-gray-700 font-medium">Countries Served</div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img
              src="/img/about.jpg"
              alt="Suncore International Facility in Dubai"
              className="w-full h-auto rounded-2xl shadow-xl object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-900/10 to-transparent rounded-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
